import { InfoKeyValue } from '@/components/info-key-value';
import { Button } from '@/components/ui/button';
import { DialogHeader, Dialog, DialogTrigger, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { getTransfer } from '@/lib/api-calls';
import { formatCurrency } from '@/lib/common-utils';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

type TransferDetailsModalProps = {
  paySentId: string | undefined;
};

export const TransferDetailsModal = (props: TransferDetailsModalProps) => {
  const { paySentId } = props;

  const [isOpen, setIsOpen] = useState(false);

  const { data: transfer } = useQuery({
    ...getTransfer(paySentId ?? undefined),
    enabled: !!paySentId && isOpen,
  });

  if (!paySentId) {
    return '-';
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <Button variant="link" className="p-0 h-auto text-blue-600 hover:text-blue-800 no-underline">
          {paySentId}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>Brex - Transfer information</DialogTitle>
          <div className="grid grid-cols-2 pt-4 gap-4">
            <InfoKeyValue label="ID" value={transfer?.id} />
            <InfoKeyValue label="Description" value={transfer?.description} />
            <InfoKeyValue label="Payment Type" value={transfer?.payment_type} />
            <InfoKeyValue
              label="Amount"
              value={transfer?.amount.amount ? formatCurrency(transfer?.amount.amount / 100) : formatCurrency(0)}
            />
            <InfoKeyValue label="Process Date" value={transfer?.process_date} />
            <InfoKeyValue label="Originating Account" value={transfer?.originating_account.id} />
            <InfoKeyValue label="Status" value={transfer?.status} />
            <InfoKeyValue label="Cancellation Reason" value={transfer?.cancellation_reason} />
            <InfoKeyValue label="Estimated Delivery Date" value={transfer?.estimated_delivery_date} />
            <InfoKeyValue label="Creator ID" value={transfer?.creator_user_id} />
            <InfoKeyValue label="Created At" value={transfer?.created_at} />
            <InfoKeyValue label="External Memo" value={transfer?.external_memo} />
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
